import { FC } from 'react';

import { Controller } from 'react-hook-form';
import { Switch } from '@headlessui/react';

interface ConfirmationPatientNotificationSectionProps {
  control: any;
}

const ConfirmationPatientNotificationSection: FC<
  ConfirmationPatientNotificationSectionProps
> = ({ control }) => {
  return (
    <>
      <div className="flex justify-between items-center text-14 leading-[2.1rem]">
        <div className="flex items-center gap-x-0.8 mb-1">
          <h3 className="font-bold">
            Sending Confirmation Email/ SMS to Patients
          </h3>
        </div>
      </div>
      <Controller
        name={'isConfirmAppointmentNotificationPatient'}
        control={control}
        render={({ field }) => {
          return (
            <div className="flex gap-x-1.6 items-center">
              <Switch
                onChange={field.onChange}
                checked={field.value}
                className={`${
                  field.value ? 'bg-magenta' : 'bg-[#78788029]'
                } relative inline-flex h-3.1 w-5.1 items-center rounded-full`}
              >
                <span
                  className={`${
                    field.value ? 'translate-x-[2.3rem]' : 'translate-x-[2px]'
                  } inline-block h-2.5 w-2.5 transform rounded-full transition bg-white`}
                />
              </Switch>
              <span className="uppercase">{field.value ? 'On' : 'Off'}</span>
            </div>
          );
        }}
      />
    </>
  );
};

export default ConfirmationPatientNotificationSection;
